/**
 * @specification
 */
export var formFieldBehavior = function formFieldBehavior(props) {
  var definition = {
    attributes: {
      root: {},
      control: Object.assign({}, props.hasErrorMessage && {
        'aria-invalid': true
      }, {
        'aria-labelledby': "" + props.labelId
      }, props.messageId && {
        'aria-labelledby': props.labelId + " " + props.messageId
      }),
      message: Object.assign({}, props.hasErrorMessage && {
        role: 'alert'
      })
    }
  };
  return definition;
};